import { render, staticRenderFns } from "./MovesList.vue?vue&type=template&id=b6ebff54&scoped=true&"
import script from "./MovesList.vue?vue&type=script&lang=js&"
export * from "./MovesList.vue?vue&type=script&lang=js&"
import style0 from "./MovesList.vue?vue&type=style&index=0&id=b6ebff54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ebff54",
  null
  
)

export default component.exports